import React from "react";
import PropTypes from "prop-types";
import SimpleText from "../SimpleText.jsx";
import UserNameContainer from "../Users/UserNameContainer.jsx";

const TaskAssignee = ({ userId, shortName, linkName, className, children }) => {
  return children ? (
    <SimpleText
      className={className}
      shortName={shortName}
      linkName={linkName}
      userId={userId}
    >
      {children}
    </SimpleText>
  ) : (
    <UserNameContainer
      className={className}
      shortName={shortName}
      linkName={linkName}
      userId={userId}
    />
  );
};

TaskAssignee.propTypes = {
  userId: PropTypes.number,
  children: PropTypes.any,
  linkName: PropTypes.bool,
  className: PropTypes.string,
  shortName: PropTypes.bool,
};

TaskAssignee.defaultProps = {
  linkName: false,
  shortName: false,
};

TaskAssignee.displayName = `TaskAssignee`;

export default TaskAssignee;
